import uuid from "uuid/v1";
import {
  createAppliedPriceTriggerPart,
  createItemAppliedPriceTriggerPart,
} from "../helpers/priceTriggerHelpers";

function CreatOrderItemObj(item, priceTriggers, appliedCoupon, orderNo) {
  var productTotalTax = 0;
  var productTotalPrice = 0;
  var productTax = computeTax({
      price: item.price,
      taxRate: item.tax,
  });
  productTotalTax += productTax;
  productTotalPrice += item.price;
  let orderitem = {
    CreatedOn: new Date().toUTCString(),
    AppliedCoupon: appliedCoupon,
    DisplayingOrder: orderNo,
    FinalTotalExcludingTax: 0,
    FinalTotalTax: 0,
    ModifyingExcludingTax: 0,
    ModifyingTax: 0,
    Name: item.name,
    Note: item.itemNote,
    OrderExtras: [],
    Product_ID: item.id,
    Quantity: item.quantity,
    Timestamps: [],
    UDID: uuid(),
    UsingTaxRate: item.tax,
    UsingUnitPrice: item.price,
    uniqueId: item.uniqueId,
    CategoryId: item.categoryId,
    CategoryName: item.categoryName,
  };

  if (item.modifiers) {
    for (var [index, md] of item.modifiers.entries()) {
      var mdQuantity = md.quantity;
      var mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      var mdTax = computeTax({
        price: md.Price * mdQuantity,
        taxRate: mdTaxRate,
      });
      var mdPriceExcludingTax = md.Price * mdQuantity - mdTax;
      var extra = {
        DisplayingOrder: index + 1,
        Extra_ID: md.ID,
        FinalPriceExcludingTax: mdPriceExcludingTax,
        FinalTax: mdTax,
        Name: md.Name,
        Quantity: mdQuantity,
        UDID: uuid(),
        UsingUnitPrice: fix2digit(md.Price),
      };
      if (md.selectedSubmodifiers) {
        extra.ChildrenOrderExtras = [];
        for (var [subindex, sub] of md.selectedSubmodifiers.entries()) {
          var subQuantity = sub.quantity;
          var subTaxRate = sub.TaxRate ? sub.TaxRate : item.tax;
          var subTax = computeTax({
            price: sub.Price * subQuantity,
            taxRate: subTaxRate,
          });
          var subPriceExcludingTax = sub.Price * subQuantity - subTax;
          var subextra = {
            DisplayingOrder: subindex + 1,
            Extra_ID: sub.ID,
            FinalPriceExcludingTax: subPriceExcludingTax,
            FinalTax: subTax,
            Name: sub.Name,
            Quantity: subQuantity,
            UDID: uuid(),
            UsingUnitPrice: fix2digit(sub.Price),
          };
          extra.ChildrenOrderExtras.push(subextra);
          productTotalTax += subTax;
          productTotalPrice += subPriceExcludingTax + subTax;
        }
      }
      orderitem.OrderExtras.push(extra);
      productTotalTax += mdTax;
      productTotalPrice += mdPriceExcludingTax + mdTax;
    }
  }
  productTotalTax = productTotalTax * item.quantity;
  productTotalPrice = productTotalPrice * item.quantity;
  orderitem["FinalTotalTax"] = fix2digit(productTotalTax);
  orderitem["FinalTotalExcludingTax"] = fix2digit(
    productTotalPrice - productTotalTax
  );
  orderitem["BaseUnitPrice"] = fix2digit(productTotalPrice);
  orderitem.AppliedPriceTriggerRecords = createItemAppliedPriceTriggerPart(
    orderitem,
    priceTriggers
  );
  return orderitem;
}

function createOrderItem(item, priceTriggers, appliedCoupon, orderNo) {
  var orderitem = CreatOrderItemObj(
    item,
    priceTriggers,
    appliedCoupon,
    orderNo
  );
  return orderitem;
}
export function getAppliedCoupon(item, appliedCouponList) {
  if (!appliedCouponList) {
    return null;
  }
  var AppliedCoupon = null;
  appliedCouponList.forEach((applied) => {
    var items = applied.appliedItems.map((a) => {
      return a.item.id;
    });
    var id = items.indexOf(item.id);
    if (id != -1) {
      AppliedCoupon = {
        CouponCode: applied.coupon.CouponCode,
        Name: applied.coupon.Name,
        Amount: applied.appliedItems[id].discount,
      };
    }
  });
  return AppliedCoupon;
}
export function CreateOrderObject(
  cartItems,
  deliveryFee,
  priceItem,
  user,
  resturant,
  card,
  guid,
  orderInfo,
  guestUserId,
  priceTriggers,
  appliedCouponList
) {
  let orderItems = [];
  let totalTax = fix2digit(priceItem.totalTax);
  let totalAmount = fix2digit(priceItem.totalPrice);
  // let freightTax = fix2digit(
  //   computeTax({
  //     price: deliveryFee,
  //     taxRate: 0.1,
  //   })
  // );
  let freightTax = 0;
  let freightExcludingTax = fix2digit(deliveryFee - freightTax);
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var orderitem = createOrderItem(
      item,
      priceTriggers,
      getAppliedCoupon(item, appliedCouponList),
      i + 1
    );
    orderItems.push(orderitem);
  }

  if (priceItem.freeOrderItems) {
    for (i = 0; i < priceItem.freeOrderItems.length; i++) {
      item = priceItem.freeOrderItems[i];
      orderitem = createOrderItem(
        item,
        priceTriggers,
        getAppliedCoupon(item, appliedCouponList) + cartItems.length + i + 1
      );
      orderItems.push(orderitem);
    }
  }

  var SubTotalAmount = fix2digit(priceItem.subTotalPrice);

  let model = {
    BankCardSurcharge: priceItem.bankCardSurcharge,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_FirstName: user.FirstName,
    ContactCustomer_LastName: user.LastName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: new Date().toUTCString(),
    CustomerMemberCode: "",
    DiscountExcludingTax: fix2digit(priceItem.discountExcludingTax),
    DiscountTax: priceItem.discountTax,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? guestUserId : "",
    InvoiceNumber: "",
    OrderNote: orderInfo.notes,
    DeliveryNote: orderInfo.DeliveryInstructions,
    OrderNumber: null,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderDeliveryTime: orderInfo.OrderDeliveryTime,
    OrderType: orderInfo.orderType,
    SubsidyOnThirdPartyDeliveryFee: orderInfo.subsidyFee,
    PaymentTransactions: [
      {
        Amount: totalAmount,
        PaymentMethodType: 0,
      },
    ],
    SurchargeTransactions: priceItem.surchargeTransactions,
    PaymentReferences: null,
    POSSurchargeExcludingTax:
      priceItem.pOSSurchargeExcludingTax - priceItem.pOSSurchargeTax,
    POSSurchargeTax: priceItem.pOSSurchargeTax,
    PaymentCardIdentifier: card ? (card.isToken ? card.token : "") : "",
    ScheduledTime: orderInfo.orderType === 2 ? new Date().toUTCString(): orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: fix2digit(SubTotalAmount - totalTax),
    SubtotalTax: totalTax,
    Source: "",
    SourceReference_ID: "",
    Timestamps: [],
    TotalExcludingTax: fix2digit(totalAmount - totalTax),
    TotalTax: totalTax,
    UDID: guid,
    AgreeToReceivePromotionalOffers:user.JoinOurMail,
    AppliedPriceTriggerRecords: createAppliedPriceTriggerPart(
      orderItems,
      priceTriggers
    ),
  };

  if(typeof user.DineInField != 'undefined') {
    model.DineInField = user.DineInField;
  }

  return model;
}

export function CreateGiftOrderObject(
  cartState,
  surchargeItem,
  user,
  resturant,
  card,
  guid,
  orderInfo,
  appliedCouponList
) {
  let orderItems = [];
  let totalTax = 0;
  let deliveryFee = cartState.isDelivery ? cartState.deliveryFee : 0;
  let freightTax = 0;
  let freightExcludingTax = fix2digit(deliveryFee - freightTax);
  for (var i = 0; i < cartState.cartItems.length; i++) {
    var item = cartState.cartItems[i];
    var itemTaxAmount = 0;
    var itemPriceWithoutTax = item.price - itemTaxAmount;
    totalTax += itemTaxAmount * item.quantity;
    var orderitem = {
      CreatedOn: new Date().toUTCString(),
      AppliedCoupon: getAppliedCoupon(item, appliedCouponList),
      DisplayingOrder: i + 1,
      FinalTotalExcludingTax: 0,
      FinalTotalTax: 0,
      ModifyingExcludingTax: 0,
      ModifyingTax: 0,
      Name: item.name,
      OrderExtras: [],
      Product_ID: item.id,
      Quantity: item.quantity,
      Timestamps: [],
      UDID: uuid(),
      UsingTaxRate: item.tax,
      UsingUnitPrice: item.price,
      AdditionalDataType: "GiftCardDetailType",
      AdditionalData: {
        FromName: item.message.From,
        ToName: item.message.To,
        ToEmail: item.message.Email,
        Message: item.message.Message,
      },
    };
    orderitem["FinalTotalTax"] = itemTaxAmount * item.quantity;
    orderitem["FinalTotalExcludingTax"] = itemPriceWithoutTax * item.quantity;
    orderItems.push(orderitem);
  }
  let totalAmount = surchargeItem.totalPrice;
  var SubTotalAmount = surchargeItem.subTotalPrice;
  //delivery price and tax
  totalAmount += deliveryFee;
  totalTax += freightTax;
  let model = {
    BankCardSurcharge: surchargeItem.bankCardSurcharge,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: new Date().toUTCString(),
    CustomerMemberCode: "",
    DiscountExcludingTax: 0,
    DiscountTax: 0,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? uuid() : "",
    InvoiceNumber: "",
    OrderNumber: null,
    IsLiability: true,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderType: orderInfo.orderType,
    PaymentTransactions: [
      {
        Amount: totalAmount,
        PaymentMethodType: 0,
      },
    ],
    PaymentReferences: null,
    SurchargeTransactions: surchargeItem.surchargeTransactions,
    POSSurchargeExcludingTax:
      surchargeItem.pOSSurchargeExcludingTax - surchargeItem.pOSSurchargeTax,
    POSSurchargeTax: surchargeItem.pOSSurchargeTax,
    PaymentCardIdentifier: card ? (card.isToken ? card.token : "") : "",
    ScheduledTime: orderInfo.orderType === 2 ? new Date().toUTCString(): orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: fix2digit(SubTotalAmount - totalTax),
    SubtotalTax: totalTax,
    Source: "",
    SourceReference_ID: "",
    Timestamps: [],
    TotalExcludingTax: totalAmount - totalTax,
    TotalTax: totalTax,
    UDID: guid,
  };

  if(typeof user.DineInField != 'undefined') {
    model.DineInField = user.DineInField;
  }
  
  return model;
}
export function fix2digit(value) {
  return Number(parseFloat(value).toFixed(2));
}

export function computeTax(item) {
  return item.price - (item.price * 100) / (item.taxRate * 100 + 100);
}
export function DiscountTax(totalTax, cartValue, discount) {
  var shopTaxRate = totalTax / cartValue; //tax rate is not always 10% so we use this to caluclate total tax percentage for the cart
  var discountValueTax = shopTaxRate * discount;
  return fix2digit(discountValueTax);
}
export function positive(val) {
  return val < 0 ? 0 : val;
}
export function TotalTaxExcludingDicountTax(cartItems) {
  let totalTax = 0;
  for (let i = 0; i < cartItems.length; i++) {
    const item = cartItems[i];
    if (!item.modifiers) {
      item.modifiers = [];
    }
    const itemTaxAmount = computeTax({
        price: item.price,
        taxRate: item.tax,
    });
    totalTax += itemTaxAmount * item.quantity;

    for (let j = 0; j < item.modifiers.length; j++) {
      const md = item.modifiers[j];
      const quantity = item.modifiers[j].quantity;
      const mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      const mdTax = computeTax({
          price: md.Price,
          taxRate: mdTaxRate,
      });
      totalTax += mdTax * quantity * item.quantity;
    }
  }
  return fix2digit(totalTax);
}
export function TotalTax(
  cartItems,
  cartValue,
  discount,
  surchargeHolidayTax
) {
  let totalTax = TotalTaxExcludingDicountTax(cartItems);
  totalTax -= DiscountTax(totalTax, cartValue, discount);
  totalTax += surchargeHolidayTax ? surchargeHolidayTax : 0;
  return fix2digit(totalTax);
}
